import { styled } from 'parkdepot-shared/theme'

export const Container = styled('div', ({ $theme }) => ({
    padding: $theme.sizing.scale700,
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale700
}))

export const TitleContainer = styled('div', () => ({
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column'
}))

export const Title = styled('h1', ({ $theme }) => ({
    ...$theme.typography.LabelLarge,
    margin: 0
}))

export const Heading = styled('h2', ({ $theme }) => ({
    ...$theme.typography.LabelSmall,
    color: $theme.colors.mono300,
    margin: 0
}))

export const SpinnerContainer = styled('div', () => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%'
}))

export const FormContainer = styled('form', ({ $theme }) => ({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: $theme.sizing.scale700
}))
